import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getAllCourseActions } from "../slices";

function* getAllCourseWorker({ payload }) {
  yield put(getAllCourseActions.pending());
  try {
    const response = yield call(courseAPI.getAllCourse, payload);
    yield put(getAllCourseActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllCourseActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllCourseWorker };
